import React, { useContext, useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import 'assets/styles/common.scss';
import 'react-calendar/dist/Calendar.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import 'Pages/Doctor/DoctorSchedule/doctorSchedule.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import EditIcon from 'assets/images/Dashboard/edit-profile.svg';
import ArrowLeftIcon from 'assets/images/Dashboard/arrow-left.svg';
import CheckBoxInput from 'components/commom/CheckBoxInput';
import LabelWithInput from 'components/commom/LabelWithInput';
import SelectInput from 'components/commom/SelectInput';
import ReusableButton from 'components/commom/Button';
import AddIcon from 'assets/images/Dashboard/add.png';
import CustomTabs from 'components/commom/CustomTabs';
import { useDispatch, useSelector } from 'react-redux';
import { getSchedule } from 'store/getSchedule/getScheduleAction';
import { ClearTokenRedirectLogin } from 'utils/general';
import { useNavigate } from 'react-router-dom';
import LocalStorageManager from 'managers/LocalStorageManger';
import { getScheduleDetail } from 'store/getScheduleDetail/getScheduleDetailAction';
import { updateAvailPost } from 'store/updateAvailablity/updateAvailablityAction';
import { createAvailPost } from 'store/createAvailablity/createAvailablityAction';
import DeleteIcon from 'assets/images/Dashboard/delete-icon.svg';
import CommonToast from 'components/commom/CommonToast';
import CommonModal from 'components/commom/Modal';
import LabelWithTextArea from 'components/commom/LabelWithTextArea';
import { markHolidayCallAPI } from 'store/markHoliday/action';
import CheckValidation from 'utils/validate';
import { getScheduleDateDetailCallAPI } from 'store/getScheduleDateDetail/action';

const localizer = momentLocalizer(moment);

const DoctorSchedule = () => {
  const { locale } = useContext(LocaleContext);
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showToast } = CommonToast();
  const [scheduleList, setScheduleList] = useState([]);
  const [tab, setTab] = useState(0);
  const [selectedEventId, setSelectedEventId] = React.useState(null);
  const [editAvailability, setEditAvailability] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectDays, setSelectDays] = useState([]);
  const [formData, setFormData] = useState({
    select_day: '',
  });
  const [holidayModal, setHolidayModal] = useState(false);
  const [formValue, setFormValue] = useState({
    startDate: moment().add(1, 'day').format('YYYY-MM-DD'),
    endDate: moment().add(1, 'day').format('YYYY-MM-DD'),
    reason: '',
  });
  const [isError, setIsError] = useState(false);

  const getAppointmentsData = useSelector(
    (state) => state?.getScheduleDetailReducer?.users?.data
  );

  const createScheduleReducer = useSelector(
    (state) => state?.createAvailReducer?.loading
  );

  const updateScheduleReducer = useSelector(
    (state) => state?.updateAvailReducer?.loading
  );

  const markHolidayLoader = useSelector(
    (state) => state?.markHolidayReducer?.loading
  );

  const getScheduleDateDetailList = useSelector(
    (state) => state?.getScheduleDateDetailReducer?.users?.data
  );

  useEffect(() => {
    if (LocalStorageManager.getItem('doctorId')) {
      handleAvailablityData();
    }
  }, [LocalStorageManager.getItem('doctorId')]);

  useEffect(() => {
    getScheduleList();
    getScheduleDateList();
  }, [selectedDate]);

  const getScheduleList = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setScheduleList(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getSchedule(external, moment(selectedDate).format('YYYY-MM-DD')));
  };

  const getScheduleDateList = () => {
    const external = {
      run: true,
      handleFunction: () => {},
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(
      getScheduleDateDetailCallAPI(
        external,
        LocalStorageManager.getItem('doctorId'),
        moment(selectedDate).format('YYYY-MM-DD')
      )
    );
  };

  const handleAvailablityData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setSelectDays(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(
      getScheduleDetail(external, LocalStorageManager.getItem('doctorId'), tab)
    );
  };

  const generateSlots = (schedule) => {
    if (!schedule) return [];

    const baseDate = schedule.exact_date;
    const availability = schedule.slots?.availability || [];
    const breaks = schedule.breaks || [];

    const slots = [];

    availability.forEach((slot, index) => {
      if (!slot.available) return;

      const start = moment(`${baseDate} ${slot.slot_start}`);
      const end = moment(`${baseDate} ${slot.slot_end}`);

      slots.push({
        id: `avail-${index}`,
        title: 'Available',
        start: start.toDate(),
        end: end.toDate(),
        type: 'available',
      });
    });

    breaks.forEach((b, index) => {
      const bStart = moment(`${baseDate} ${b.start_time}`);
      const bEnd = moment(`${baseDate} ${b.end_time}`);

      slots.push({
        id: `break-${index}`,
        title: 'Break',
        start: bStart.toDate(),
        end: bEnd.toDate(),
        type: 'break',
      });
    });

    return slots;
  };

  // const formattedEvents = scheduleList.map((event) => ({
  //   id: event.id,
  //   title: `Appointment with ${event?.patient?.full_name} - ${event?.consultation_type}`,
  //   start: new Date(event?.appointment_date_time),
  //   end: new Date(new Date(event.appointment_date_time)),
  // }));

  const slotEvents = getScheduleDateDetailList?.[0]
    ? generateSlots(getScheduleDateDetailList[0])
    : [];

  const formattedEvents = [
    ...scheduleList.map((event) => ({
      id: event.id,
      title: `Appointment with ${event?.patient?.full_name} - ${event?.consultation_type}`,
      start: new Date(event?.appointment_date_time),
      end: new Date(event?.appointment_date_time),
      type: 'booked',
    })),

    ...slotEvents, // <-- merge slots
  ];

  const handleSelectEvent = (event) => {
    setSelectedEventId(event.id);
  };

  const dayPropGetter = (date) => {
    if (moment(date).isSame(moment(), 'day')) {
      return {
        style: {
          backgroundColor: 'transparent',
        },
      };
    }
    return {};
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const highlightWeekends = ({ date }) => {
    const today = new Date().toDateString();
    const day = date.getDay();
    const isToday = date.toDateString() === today;
    const isSelected = date.toDateString() === selectedDate?.toDateString();

    if (isSelected) return 'selected';
    if (isToday) return 'today';
    if (day === 0) return 'sunday-highlight';
    if (day === 6) return 'saturday-highlight';
    return null;
  };

  const handleNavigationClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const disablePastDates = ({ date }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  };

  const tabData = [
    {
      label: intl.formatMessage({ id: 'Mon' }),
      slug: intl.formatMessage({ id: 'Monday' }),
      isHoliday: false,
      shift: { start: '', end: '' },
      day_of_week: { day: '', day_of_week_id: '' },
      appointment_length: '',
      buffer_length: '',
      breaks: [],
      isShow: false,
      weekId: 17,
    },
    {
      label: intl.formatMessage({ id: 'Tue' }),
      slug: intl.formatMessage({ id: 'Tuesday' }),
      isHoliday: false,
      shift: { start: '', end: '' },
      day_of_week: { day: '', day_of_week_id: '' },
      appointment_length: '',
      buffer_length: '',
      breaks: [],
      isShow: false,
      weekId: 18,
    },
    {
      label: intl.formatMessage({ id: 'Wed' }),
      slug: intl.formatMessage({ id: 'Wednesday' }),
      isHoliday: false,
      shift: { start: '', end: '' },
      day_of_week: { day: '', day_of_week_id: '' },
      appointment_length: '',
      buffer_length: '',
      breaks: [],
      isShow: false,
      weekId: 19,
    },
    {
      label: intl.formatMessage({ id: 'Thu' }),
      slug: intl.formatMessage({ id: 'Thursday' }),
      isHoliday: false,
      shift: { start: '', end: '' },
      day_of_week: { day: '', day_of_week_id: '' },
      appointment_length: '',
      buffer_length: '',
      breaks: [],
      isShow: false,
      weekId: 20,
    },
    {
      label: intl.formatMessage({ id: 'Fri' }),
      slug: intl.formatMessage({ id: 'Friday' }),
      isHoliday: false,
      shift: { start: '', end: '' },
      day_of_week: { day: '', day_of_week_id: '' },
      appointment_length: '',
      buffer_length: '',
      breaks: [],
      isShow: false,
      weekId: 21,
    },
    {
      label: intl.formatMessage({ id: 'Sat' }),
      slug: intl.formatMessage({ id: 'Saturday' }),
      isHoliday: false,
      shift: { start: '', end: '' },
      day_of_week: { day: '', day_of_week_id: '' },
      buffer_length: '',
      breaks: [],
      isShow: false,
      weekId: 22,
    },
    {
      label: intl.formatMessage({ id: 'Sun' }),
      slug: intl.formatMessage({ id: 'Sunday' }),
      isHoliday: false,
      shift: { start: '', end: '' },
      day_of_week: { day: '', day_of_week_id: '' },
      appointment_length: '',
      buffer_length: '',
      breaks: [],
      isShow: false,
      weekId: 16,
    },
  ];

  const handleTabChange = (val) => {
    setTab(val);
    setFormData((prev) => ({
      ...prev,
      ['select_day']: '',
    }));
  };

  const handleAvailablity = () => {
    setEditAvailability(true);
    handleAvailablityData();
  };

  function convertTo24HourFormat(time12h) {
    return moment(time12h, ['h:mm A']).format('HH:mm');
  }

  const [tabDetails, setTabDetails] = useState(tabData);

  useEffect(() => {
    if (getAppointmentsData?.length > 0) {
      const updatedTabDetails = tabData.map((tab) => {
        const matchingAppointment = getAppointmentsData.find(
          (appointment) => appointment?.day_of_week?.day === tab.slug
        );

        const matchingAppointmentIndex = getAppointmentsData.findIndex(
          (appointment) => appointment?.day_of_week?.day === tab.slug
        );

        if (matchingAppointment) {
          return {
            ...tab,
            isHoliday:
              getAppointmentsData?.[matchingAppointmentIndex]?.is_week_off,
            id: getAppointmentsData?.[matchingAppointmentIndex]?.id,
            shift: {
              start: convertTo24HourFormat(
                getAppointmentsData?.[matchingAppointmentIndex]?.start_time
              ),
              end: convertTo24HourFormat(
                getAppointmentsData?.[matchingAppointmentIndex]?.end_time
              ),
            },
            day_of_week: {
              day: getAppointmentsData?.[matchingAppointmentIndex]?.day_of_week
                ?.day,
              day_of_week_id:
                getAppointmentsData?.[matchingAppointmentIndex]?.day_of_week
                  ?.id,
            },
            appointment_length:
              getAppointmentsData?.[matchingAppointmentIndex]
                ?.appointment_length,
            buffer_length:
              getAppointmentsData?.[matchingAppointmentIndex]?.buffer_length,
            breaks: getAppointmentsData?.[
              matchingAppointmentIndex
            ]?.breaks?.map((bItem) => ({
              start_time: convertTo24HourFormat(bItem?.start_time),
              end_time: convertTo24HourFormat(bItem?.end_time),
            })) || [{ start_time: '', end_time: '' }],
            isShow: true,
          };
        }
        return tab;
      });

      setTabDetails(updatedTabDetails);
    }
  }, [getAppointmentsData]);

  const handleShiftChange = (tabIndex, field, value) => {
    const updatedDetails = [...tabDetails];
    updatedDetails[tabIndex].shift[field] = value;
    setTabDetails(updatedDetails);
  };

  const handleSelect = (tabIndex, name, value) => {
    const updatedDetails = [...tabDetails];
    updatedDetails[tabIndex][name] = value?.value;
    setTabDetails(updatedDetails);
  };

  const handleBreakChange = (tabIndex, breakIndex, field, value) => {
    const updatedDetails = [...tabDetails];
    updatedDetails[tabIndex].breaks[breakIndex][field] = value;
    setTabDetails(updatedDetails);
  };

  const handleAddBreak = (tabIndex) => {
    const updatedDetails = [...tabDetails];
    updatedDetails[tabIndex].breaks.push({
      start_time: '',
      end_time: '',
    });
    setTabDetails(updatedDetails);
  };

  const handleCreateAppointments = (tabValue, tabIndex) => {
    const updatedDetails = [...tabDetails];
    updatedDetails[tabIndex].isShow = true;
    setTabDetails(updatedDetails);
  };

  const handleSelectDaysChange = (event, tabIndex) => {
    const value = event?.target?.value;
    setFormData((prev) => ({
      ...prev,
      ['select_day']: value?.day_of_week?.day,
    }));
    const updatedDetails = [...tabDetails];
    updatedDetails[tabIndex].shift['start'] = value?.start_time;
    updatedDetails[tabIndex].shift['end'] = value?.end_time;
    updatedDetails[tabIndex]['appointment_length'] = value?.appointment_length;
    updatedDetails[tabIndex]['buffer_length'] = value?.buffer_length;
    value?.breaks.map((item, index) => {
      updatedDetails[tabIndex].breaks.push({
        start_time: item?.start_time,
        end_time: item?.end_time,
      });
    });
    updatedDetails[tabIndex].isShow = true;
    updatedDetails[tabIndex].isHoliday = value?.is_week_off;

    setTabDetails(updatedDetails);
  };

  const handleRemoveBreak = (tabIndex, breakIndex) => {
    const updatedDetails = [...tabDetails];
    updatedDetails[tabIndex].breaks = updatedDetails[tabIndex].breaks.filter(
      (_, index) => index !== breakIndex
    );
    setTabDetails(updatedDetails);
  };

  const handleSaveDetails = (tabValue) => {
    const external = {
      run: true,
      handleFunction: (res) => {
        handleSuccess(res);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    const indicesToSave = tabDetails.findIndex(
      (tab) => tab.label === tabValue.label
    );

    if (indicesToSave === -1) {
      showToast('Tab not found', 'error');
      return;
    }

    const selectedTab = tabDetails?.[indicesToSave];
    const { shift, appointment_length } = selectedTab || {};

    if (!selectedTab?.isHoliday) {
      if (!shift?.start) {
        showToast('Please enter a start time', 'error');
        return;
      }
      if (!shift?.end) {
        showToast('Please enter an end time', 'error');
        return;
      }
      if (!appointment_length) {
        showToast('Please enter an appointment length', 'error');
        return;
      }
    }

    if (tabDetails?.[indicesToSave]?.id) {
      let body = {
        is_week_off: tabDetails[indicesToSave]?.isHoliday,
        day_of_week_id: tabDetails[indicesToSave]?.day_of_week?.day_of_week_id,
      };
      if (!tabDetails[indicesToSave]?.isHoliday) {
        body.start_time = tabDetails?.[indicesToSave]?.shift?.start;
        body.end_time = tabDetails?.[indicesToSave]?.shift?.end;
        body.appointment_length =
          tabDetails?.[indicesToSave]?.appointment_length;
        body.buffer_length = tabDetails?.[indicesToSave]?.buffer_length;
        body.breaks = tabDetails?.[indicesToSave]?.breaks;
      }

      dispatch(
        updateAvailPost(body, external, tabDetails?.[indicesToSave]?.id)
      );
    } else {
      let body = {
        is_week_off: tabDetails[indicesToSave]?.isHoliday,
        day_of_week_id: tabDetails[indicesToSave]?.weekId,
      };
      if (!tabDetails[indicesToSave]?.isHoliday) {
        body.start_time = tabDetails?.[indicesToSave]?.shift?.start;
        body.end_time = tabDetails?.[indicesToSave]?.shift?.end;
        body.appointment_length =
          tabDetails?.[indicesToSave]?.appointment_length;
        body.buffer_length = tabDetails?.[indicesToSave]?.buffer_length;
        body.breaks = tabDetails?.[indicesToSave]?.breaks;
      }
      dispatch(createAvailPost(body, external));
    }
  };

  const handleSuccess = (res) => {
    showToast(res?.message, 'success');
    setTimeout(() => {
      setEditAvailability(false);
      handleAvailablityData();
      getScheduleDateList();
    }, 1000);
  };

  const handleHolidayClose = () => {
    setHolidayModal(false);
    setFormValue({
      startDate: moment().add(1, 'day').format('YYYY-MM-DD'),
      endDate: moment().add(1, 'day').format('YYYY-MM-DD'),
      reason: '',
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    const error = CheckValidation({ reason: formValue?.reason });
    setIsError(error);
    if (error.submit) {
      const external = {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          handleHolidayClose();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      };
      const body = {
        start_date: formValue?.startDate,
        end_date: formValue?.endDate,
        reason: formValue?.reason,
      };
      dispatch(markHolidayCallAPI(external, body));
    }
  };

  const tabShiftDetails = (tabValue, tabIndex) => {
    const currentTabDetails = tabDetails[tabIndex];
    const isHolidayDisabled = currentTabDetails.isHoliday ? 'opacity-50' : '';

    return (
      <>
        {currentTabDetails?.isShow ? (
          <>
            <div className="mt-3">
              <CheckBoxInput
                label={<FormattedMessage id="Weekly-off" />}
                size="14"
                fontWeight="500"
                onChange={(e) => {
                  const updatedDetails = [...tabDetails];
                  updatedDetails[tabIndex].isHoliday = e.target.checked;
                  setTabDetails(updatedDetails);
                }}
                checked={currentTabDetails.isHoliday}
              />
            </div>

            <h3
              className={`p-0 m-0 mt-4 fs-16 fc-292D32 family_outfit_semiBold_600 ${isHolidayDisabled}`}
            >
              <FormattedMessage id="Shift Details" />
            </h3>

            <Row className={`m-0 p-0 ${isHolidayDisabled}`}>
              <Col md={12} lg={6} className="mt-3 p-0">
                <LabelWithInput
                  label="Start Time"
                  type="time"
                  value={currentTabDetails.shift.start}
                  disabled={currentTabDetails.isHoliday}
                  onChange={(e) =>
                    handleShiftChange(tabIndex, 'start', e.target.value)
                  }
                />
              </Col>

              <Col md={12} lg={6} className="mt-3 size-padding-schedule">
                <LabelWithInput
                  label="End Time"
                  type="time"
                  value={currentTabDetails.shift.end}
                  disabled={currentTabDetails.isHoliday}
                  onChange={(e) =>
                    handleShiftChange(tabIndex, 'end', e.target.value)
                  }
                />
              </Col>
              <Col md={6} lg={6} className="mt-3 p-0">
                <p className=" p-0 m-0 fs-14 lh-176 fc-292D32 family_outfit_regular_400">
                  Appointment length
                </p>
                <SelectInput
                  placeholder={intl.formatMessage({
                    id: 'Appointment length',
                  })}
                  name={'appointment_length'}
                  value={
                    currentTabDetails?.appointment_length !== ''
                      ? `${currentTabDetails?.appointment_length} minutes`
                      : currentTabDetails?.appointment_length
                  }
                  data={[
                    { name: '15 minutes', value: '15' },
                    { name: '30 minutes', value: '30' },
                    { name: '45 minutes', value: '45' },
                  ]}
                  onChange={(e) =>
                    handleSelect(tabIndex, 'appointment_length', e.target.value)
                  }
                  disabled={currentTabDetails?.isHoliday}
                />
              </Col>
              <Col md={6} lg={6} className="mt-3 size-padding-schedule">
                <p className=" p-0 m-0 fs-14 lh-176 fc-292D32 family_outfit_regular_400">
                  Buffer length
                </p>
                <SelectInput
                  placeholder={intl.formatMessage({
                    id: 'Buffer length',
                  })}
                  name={'buffer_length'}
                  value={
                    currentTabDetails?.buffer_length !== ''
                      ? ` ${currentTabDetails?.buffer_length} minutes`
                      : currentTabDetails?.buffer_length
                  }
                  data={[
                    { name: '15 minutes', value: '15' },
                    { name: '30 minutes', value: '30' },
                    { name: '45 minutes', value: '45' },
                  ]}
                  onChange={(e) =>
                    handleSelect(tabIndex, 'buffer_length', e.target.value)
                  }
                  disabled={currentTabDetails?.isHoliday}
                />
              </Col>
            </Row>

            <h3
              className={`p-0 m-0 mt-4 fs-16 fc-292D32 family_outfit_semiBold_600 ${isHolidayDisabled}`}
            >
              <FormattedMessage id="Break(s)" />
            </h3>

            <Row className={`m-0 p-0 ${isHolidayDisabled}`}>
              {currentTabDetails.breaks.map((breakTime, index) => (
                <>
                  <div className="flex justify-between">
                    <h3 className="p-0 m-0 mt-4 fs-14 fc-292D32 ff-Akkurat ">
                      <FormattedMessage id={`Break ${index + 1}`} />
                    </h3>
                    <Image
                      src={DeleteIcon}
                      alt="iocn"
                      className="cursor-pointer ..."
                      onClick={() => handleRemoveBreak(tabIndex, index)}
                    />
                  </div>

                  <Col md={12} lg={6} className="mt-3 p-0">
                    <LabelWithInput
                      label={`Start Time`}
                      type="time"
                      format="h:mm a"
                      value={breakTime.start_time}
                      disabled={currentTabDetails.isHoliday}
                      onChange={(e) =>
                        handleBreakChange(
                          tabIndex,
                          index,
                          'start_time',
                          e.target.value
                        )
                      }
                    />
                  </Col>

                  <Col md={12} lg={6} className="mt-3 size-padding-schedule">
                    <LabelWithInput
                      label={`End Time`}
                      type="time"
                      format="h:mm a"
                      value={breakTime.end_time}
                      disabled={currentTabDetails.isHoliday}
                      onChange={(e) =>
                        handleBreakChange(
                          tabIndex,
                          index,
                          'end_time',
                          e.target.value
                        )
                      }
                    />
                  </Col>
                </>
              ))}
            </Row>

            <Row className={`m-0 p-0 mt-3 ${isHolidayDisabled}`}>
              <ReusableButton
                fullWidth={false}
                variant="outlined"
                color="#C56616"
                fontSize="14px"
                fontWeight="500"
                padding="12px 25px"
                height="40px"
                borderRadius={'8px'}
                bgColor="transparent"
                brColor="#EFE3D7"
                fontFamily="outfit_medium"
                disabled={currentTabDetails?.isHoliday}
                onClick={() => handleAddBreak(tabIndex)}
              >
                <img
                  src={AddIcon}
                  alt="icon"
                  style={{ height: '24px', width: '24px' }}
                  className="me-2"
                />
                <FormattedMessage id="Add break" />
              </ReusableButton>
            </Row>

            <Row className="m-0 p-0 mt-4 flex text-end items-center justify-end">
              <Stack
                direction="horizontal"
                gap={2}
                className="items-center justify-end p-0"
              >
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#3C3C3C"
                  fontSize="14px"
                  fontWeight="500"
                  padding="12px 50px"
                  height="44px"
                  bgColor="transparent"
                  brColor="#EFE3D7"
                  fontFamily="outfit_medium"
                  onClick={() => setEditAvailability(false)}
                >
                  <FormattedMessage id="Cancel" />
                </ReusableButton>

                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="14px"
                  fontWeight="500"
                  padding="12px 50px"
                  height="44px"
                  bgColor="#375241"
                  brColor="#375241"
                  fontFamily="outfit_medium"
                  onClick={() => {
                    (!createScheduleReducer || !updateScheduleReducer) &&
                      handleSaveDetails(tabValue);
                  }}
                  loading={createScheduleReducer || updateScheduleReducer}
                >
                  <FormattedMessage id="Save" />
                </ReusableButton>
              </Stack>
            </Row>
          </>
        ) : (
          <>
            <div className="flex-col items-center justify-center  mt-5 pt-5 mb-5 pb-5">
              {getAppointmentsData && getAppointmentsData?.length > 0 && (
                <>
                  <div className="mt-5">
                    <p className="p-0 m-0 fs-16 fc-292D32 family_outfit_medium_500 text-center">
                      <FormattedMessage id="Copy availability from an existing day" />
                    </p>
                    <Row className="flex justify-center mt-4">
                      <Col md={4}>
                        <SelectInput
                          label="Select Day"
                          placeholder={intl.formatMessage({
                            id: 'Select Day',
                          })}
                          name={'state'}
                          value={formData?.select_day}
                          data={selectDays}
                          onChange={(e) => handleSelectDaysChange(e, tabIndex)}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="mt-4 fs-16 fc-292D32 family_outfit_medium_500 text-center">
                    <FormattedMessage id="Or" />
                  </div>
                </>
              )}
              <div className="pt-3">
                <p className="p-0 m-0 fs-16 fc-292D32 family_outfit_medium_500 text-center">
                  <FormattedMessage id="Set your availability for customers" />
                </p>
              </div>
              <div className="mt-4 mb-5 pb-5 text-center">
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#C56616"
                  fontSize="14px"
                  fontWeight="500"
                  padding="12px 25px"
                  height="40px"
                  bgColor="transparent"
                  brColor="#EFE3D7"
                  fontFamily="outfit_medium"
                  onClick={() => handleCreateAppointments(tabValue, tabIndex)}
                >
                  <img
                    src={AddIcon}
                    alt="icon"
                    style={{ height: '24px', width: '24px' }}
                    className="me-2"
                  />
                  <FormattedMessage id="Create New" />
                </ReusableButton>
              </div>
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <Row className="bc-FEF9F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
            : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
        }
      >
        <Row className="">
          <Col className="p-0">
            <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 pb-16 m-0">
              <FormattedMessage id="Schedule Today" />
            </h2>
          </Col>
        </Row>

        <Row className="g-4">
          <Col md={6} lg={4} xl={3} className="p-0">
            <div className="calendar-container">
              <Calendar
                next2Label={null}
                prev2Label={null}
                tileClassName={highlightWeekends}
                formatShortWeekday={(locale, date) => date.toString().charAt(0)}
                onChange={handleDateChange}
                value={selectedDate}
                tileDisabled={disablePastDates}
                navigationLabel={({ date, label }) => (
                  <button
                    onClick={handleNavigationClick}
                    style={{
                      minWidth: '44px',
                      background: 'none',
                      cursor: 'not-allowed',
                    }}
                    disabled
                  >
                    {label}
                  </button>
                )}
              />
              <div className="mt-[20px]">
                <ReusableButton
                  fullWidth={true}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="14px"
                  fontWeight="500"
                  padding="12px 50px"
                  height="44px"
                  bgColor="#375241"
                  brColor="#375241"
                  fontFamily="outfit_medium"
                  onClick={() => {
                    setHolidayModal(true);
                  }}
                  loading={false}
                >
                  Mark as Holiday
                </ReusableButton>
              </div>
            </div>
          </Col>
          <Col xl={8} className="size-padding-large">
            {!editAvailability ? (
              <div className="w-100">
                <div className="flex justify-between">
                  <h2 className="p-0 m-0 fs-24 fw-400 fc-292D32 ff-Akkurat">
                    {moment(selectedDate).format('MMM DD, YYYY')}
                    {getScheduleDateDetailList?.[0]?.is_week_off
                      ? '( Weekly-off )'
                      : getScheduleDateDetailList?.[0]?.is_holiday
                        ? '( Holiday )'
                        : ''}
                  </h2>
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center cursor-pointer"
                    onClick={() => handleAvailablity()}
                  >
                    <img
                      src={EditIcon}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                    />
                    <p className="p-0 m-0 fs-16 fc-C56616 family_outfit_medium_500 ">
                      {getAppointmentsData &&
                      getAppointmentsData?.length > 0 ? (
                        <FormattedMessage id="Edit Availability" />
                      ) : (
                        <FormattedMessage id="Add Availability" />
                      )}
                    </p>
                  </Stack>
                </div>
                <div className="big-calendar-container mt-3">
                  {/* <BigCalendar
                    localizer={localizer}
                    events={formattedEvents}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 'auto' }}
                    views={['day']}
                    defaultView="day"
                    date={selectedDate}
                    toolbar={false}
                    dayLayoutAlgorithm="no-overlap"
                    dayPropGetter={dayPropGetter}
                    eventPropGetter={(event) => {
                      if (selectedEventId && event.id === selectedEventId) {
                        return {
                          style: {
                            border: '1px solid #FEF9F6',
                            backgroundColor: '#FEF9F6',
                            outline: 'none',
                          },
                        };
                      }
                      return {
                        style: {
                          border: '1px solid #FEF9F6',
                          outline: 'none',
                        },
                      };
                    }}
                    onSelectEvent={handleSelectEvent}
                  /> */}
                  <BigCalendar
                    localizer={localizer}
                    events={formattedEvents}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: 'auto' }}
                    views={['day']}
                    defaultView="day"
                    date={selectedDate}
                    toolbar={false}
                    dayLayoutAlgorithm="no-overlap"
                    dayPropGetter={dayPropGetter}
                    eventPropGetter={(event) => {
                      let style = {
                        border: '1px solid #ddd',
                        outline: 'none',
                      };

                      switch (event.type) {
                        case 'available':
                          style.backgroundColor = '#E8FFF1'; // light green
                          break;
                        case 'buffer':
                          style.backgroundColor = '#FFFFFF'; // white
                          break;
                        case 'break':
                          style.backgroundColor = '#FFE4E4'; // red
                          break;
                        case 'booked':
                          style.backgroundColor = '#FEF9F6'; // brown
                          break;
                      }

                      // selected event highlight
                      if (event.id === selectedEventId) {
                        style.border = '2px solid #000';
                      }

                      return { style };
                    }}
                    onSelectEvent={handleSelectEvent}
                  />
                </div>
              </div>
            ) : (
              <>
                <div className="w-100 border-1 bColor-EFE3D7 bc-FFFFFF p-4">
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center"
                  >
                    <img
                      src={ArrowLeftIcon}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                      onClick={() => setEditAvailability(false)}
                      className="cursor-pointer"
                    />
                    <p className="p-0 m-0 fs-20 fc-292D32 family_outfit_medium_500 ">
                      <FormattedMessage id="Set Availability" />
                    </p>
                  </Stack>

                  <div className="mt-3">
                    <CustomTabs
                      tabs={tabData}
                      value={tab}
                      currentTab={(val) => handleTabChange(val)}
                      tabStyles={{
                        fontSize: '18px',
                        color: '#998A7B',
                        selectedColor: '#C56616',
                      }}
                      indicatorColor="#C56616"
                    />
                  </div>

                  {tabData.map((k, i) => tab === i && tabShiftDetails(k, i))}
                </div>
              </>
            )}
          </Col>
        </Row>
      </Col>
      <CommonModal
        padding={'24px'}
        width={'694px'}
        modalActive={holidayModal}
        innerContent={
          <div>
            <Row>
              <Col md={12} className="p-0 m-0">
                <div className="fs-24 fc-242E39 lh-3024 family_outfit_semiBold_600">
                  Mark as Holiday
                </div>
              </Col>
              <Col md={12} className="p-0">
                <div className="pt-[40px]">
                  <div>
                    <LabelWithInput
                      label="Start Date"
                      type="date"
                      name="startDate"
                      value={formValue?.startDate}
                      disabled={false}
                      min={moment().add(1, 'day').format('YYYY-MM-DD')}
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                    />
                  </div>
                  <div className="mt-[20px]">
                    <LabelWithInput
                      label="End Date"
                      type="date"
                      name="endDate"
                      value={formValue?.endDate}
                      disabled={false}
                      min={
                        formValue?.startDate
                          ? formValue.startDate // allow same date as start date
                          : moment().add(1, 'day').format('YYYY-MM-DD')
                      }
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                    />
                  </div>
                  <div className="mt-[20px]">
                    <div className="fs-17 lh-21 mb-1 fc-292D32 family_outfit_medium_500">
                      Reason
                    </div>
                    <LabelWithTextArea
                      placeholder={intl.formatMessage({ id: 'Write here...' })}
                      height="100"
                      multiline
                      name="reason"
                      Color={'#212426'}
                      padding={'8px'}
                      value={formValue?.reason}
                      onChange={(e) => {
                        handleInputChange(e);
                      }}
                      errorText={
                        isError &&
                        isError?.reason?.error &&
                        isError?.reason?.errorMessage
                      }
                    />
                  </div>
                </div>
              </Col>
              <Col md={12} className="p-0 flex justify-end mt-4">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center pt-16"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="400"
                    padding="14px 55px"
                    height="40px"
                    bgColor="transparent"
                    brColor="#375241"
                    fontFamily="outfit_regular"
                    onClick={() => {
                      handleHolidayClose();
                    }}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="500"
                    padding="14px 55px"
                    height="40px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    loading={markHolidayLoader}
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    <FormattedMessage id="Done" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </Row>
  );
};

export default DoctorSchedule;
